__turbopack_context__.v({
  "active": "platform-module-scss-module__eWxa4q__active",
  "platform-inner-img": "platform-module-scss-module__eWxa4q__platform-inner-img",
  "tabs-platform": "platform-module-scss-module__eWxa4q__tabs-platform",
});
